module.exports = __webpack_public_path__ + "67870b089b4c93bd11a87f07f9169f92.jpg";